import { useTranslation } from '@pancakeswap/localization'
import { Flex, HelpIcon, Text, useTooltip } from '@pancakeswap/uikit'
import { FarmRewardState } from './farmRewardState'

/** APR cell when no CBON reward period is running for the farm: a plain label, never a computed APR. */
const RewardsNotRunning: React.FC<{ state: Exclude<FarmRewardState, 'running'>; periodEnd?: number; fontSize?: string }> = ({
  state,
  periodEnd,
  fontSize = '14px',
}) => {
  const { t } = useTranslation()
  const ended = periodEnd ? new Date(periodEnd * 1000).toISOString().slice(0, 10) : undefined
  const { targetRef, tooltip, tooltipVisible } = useTooltip(
    <Text small>
      {state === 'notStarted'
        ? t('No CBON reward period is running for this farm yet. The APR shows once rewards start.')
        : t('No CBON reward period is running. The last one ended on %date%. Staked positions can still be withdrawn.', {
            date: ended ?? '—',
          })}
    </Text>,
    { placement: 'top' },
  )
  return (
    <Flex ref={targetRef} alignItems="center" style={{ gap: 4, cursor: 'help' }} data-testid="farm-rewards-state">
      <Text fontSize={fontSize} color="textSubtle">
        {state === 'notStarted' ? t('Rewards not started') : t('Rewards ended')}
      </Text>
      <HelpIcon width="16px" height="16px" color="textSubtle" />
      {tooltipVisible && tooltip}
    </Flex>
  )
}

export default RewardsNotRunning
